import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';
import { useAddHoldingClassModal } from '../context/AddHoldingClassModalContext';

const AddHoldingClassModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddHoldingClassModal();

  const modalTitle = {
    [actionTypes.ADD]: t('Add'),
    [actionTypes.EDIT]: t('Edit'),
    [actionTypes.VIEW]: t('Details'),
  };

  return (
    <Modal.Header>
      <h5 className="modal-title">
        {modalTitle[data.modalActionType]}
        {` ${t('Class')}`}
      </h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddHoldingClassModalHeader;
